import { FeedbackCommentEditor } from "@pjs/feedback";
import { react2angular } from "@pebblepad/react2angular";
import { angularAMD } from "@pebblepad/amd";

angularAMD.component("feedbackCommentEditor", react2angular(FeedbackCommentEditor, ["content", "ariaLabel", "onChange", "onLink", "placeholder", "autoFocus", "statements", "onToolbarDisplayChange"]));
